export default __webpack_public_path__ + "static/media/hospital-img-3.1be8ea49.png";